<template>
  <div>
    <span v-if="!produto.$melhorPreco">
    {{ preco | currency('R$', produto.produto.cotacaoProduto.produto.casasDecimais) }}
      <small v-if="showPercentualIcms && icms">({{ icms | number('0.00') }}%)</small>
    </span>
    <v-chip v-if="produto.$melhorPreco" label class="success my-1">
      {{ preco | currency('R$', produto.produto.cotacaoProduto.produto.casasDecimais) }}
      <small v-if="showPercentualIcms && icms">({{ icms | number('0.00') }}%)</small>
    </v-chip>
  </div>
</template>

<script>
import { SituacaoRespostaCotacaoProduto } from 'px-business-components';
import currency from 'currency.js';
import { DEFAULT_PRECISION } from '@/utils/produto-utils';

export default {
  props: {
    produto: Object,
    hideIcms: Boolean,
    showPercentualIcms: {
      type: Boolean,
      default: false,
    },
    showPrecoTarget: Boolean,
  },
  computed: {
    preco() {
      if (!this.hideIcms || !this.produto.produto.impostos.icms) {
        return this.produto.produto.valorMoedaConvertido.precoUnitario;
      }
      return this.produto.produto.precoSemIcms;
    },
    icms() {
      return this.produto.produto.impostos.icms
        ? currency(this.produto.produto.impostos.icms, { precision: DEFAULT_PRECISION })
          .multiply(100)
          .value
        : 0;
    },
    situacao() {
      return SituacaoRespostaCotacaoProduto.keys[this.produto.produto.situacao].description;
    },
  },
};
</script>
